export default "__VITE_ASSET__CfGT6woV__"